import { axiosInstance } from "@/axios/axiosInstance";
import { Payment } from "@/types/payment";
import { PaginatedResponse, QueryParamsBase } from "@/types/types";

export interface PaymentsPaginatedResponse
  extends PaginatedResponse<Payment> {
  total_payment_amount: number;
  total_tip_amount?: number;
  total_discount_amount?: number;
  payments_count?: number;

}

export const getPayments = async (
  params?: QueryParamsBase &  { pageSize?: number; select?: string[] },
): Promise<PaymentsPaginatedResponse> => {
  const { data } = await axiosInstance.get("/v2/payments", {
    params,
  });
  return data;
};

export const getPaymentId = async (
  register_id: string,
): Promise<Payment | null> => {
  const { data } = await axiosInstance.get(`/v2/payments/${register_id}`);
  return data;
};
